module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table>\r\n  <tr>\r\n    ';
 if(readonly) { 
__p+='\r\n      <td><span class="phx-referentiel-item-text" title="'+
((__t=(model.label ))==null?'':__t)+
'">'+
((__t=(model.label ))==null?'':__t)+
'</span></td>\r\n      ';
 } else { 
__p+='\r\n        <td><span class="phx-referentiel-item-text" title="'+
((__t=(model.label ))==null?'':__t)+
'">'+
((__t=(model.label ))==null?'':__t)+
'</span></td>\r\n        <td><span class="phx-referentiel-item-icon ui-icon ui-icon-close"></span></td>\r\n        ';
 }
__p+='\r\n  </tr>\r\n</table>';
}
return __p;
};
